const schedule_data = [
    {
        date : '4TH NOVEMBER',
        time : '11:00 AM',
        name : "REGISTRATION OPENS FOR ALL EVENTS",
    },
    {
        date : '10TH NOVEMBER',
        time : '08:00 PM',
        name : "REGISTRATION CLOSES FOR ALL EVENTS",
    },
    {
        date : '11TH NOVEMBER',
        time : '03:00 PM',
        name : "INAUGURATION CEREMONY",
    },
    {
        date : '11TH NOVEMBER',
        time : '03:30 PM',
        name : "BEGINNING OF DEPARTMENTAL ROUNDS",
    },
    {
        date : '12TH NOVEMBER',
        time : '10:30 AM',
        name : "OPENING OF STALLS",
    },
    {
        date : '12TH NOVEMBER',
        time : '01:30 PM',
        name : "BEGINNING OF INSTITUTIONAL ROUNDS",
    },
    {
        date : '14TH NOVEMBER',
        time : '04:00 PM',
        name : "FELICITATION CEREMONY",
    },
]

export default schedule_data;